import { render, staticRenderFns } from "./gridOrlistOdds.vue?vue&type=template&id=78029e5f"
import script from "./gridOrlistOdds.vue?vue&type=script&lang=js"
export * from "./gridOrlistOdds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports